export const GET_COURSE_DETAIL = 'GET_COURSE_DETAIL';
export const GET_LESSON_LIST = 'GET_LESSON_LIST';
export const COURSE_EXIST = 'COURSE_EXIST';
export const GET_COURSE_REQUEST = 'GET_COURSE_REQUEST';
